import React from "react";
import woodsLocationMap from "../../assets/meadows-images/vessella-meadows-map.avif";

export default function LocationMeadows() {
    return (
        <section className="woods-location-section" id="woods-location">
            <img
                src={woodsLocationMap}
                alt="Vessella Meadows location map"
                className="woods-location-iframe"
                loading="lazy"
            />
        </section>
    );
}
